var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('react-button',{attrs:{"isReacted":_vm.model.meta.isFollowed,"name":'Follow',"icon":'thumbtack'},on:{"toggleOn":function($event){_vm.$emit('toggleOn')},"toggleOff":function($event){_vm.$emit('toggleOff')}}})}
var staticRenderFns = []

export { render, staticRenderFns }